import { Component, ViewChild, ElementRef, HostListener, Input, Output, EventEmitter, OnChanges, signal, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { IMPORTS } from './_imports';
import { Enums } from '../../../../shared/enums';

@Component({
    selector: 'help-menu',
    templateUrl: './help-menu.component.html',
    styleUrl: './help-menu.component.scss',
    standalone: true,
    imports: IMPORTS
})
export class HelpMenuComponent implements OnInit, OnChanges {
    // #region [ViewChild]
    @ViewChild('dropdownMenuRef') dropdownMenuRef: ElementRef;
    @ViewChild('headerButtonRef') headerButtonRef: ElementRef;
    // #endregion

    // #region [listeners]
    @HostListener('document:click', ['$event'])
    clickout(event) {
        if (this.dropdownMenuRef?.nativeElement?.classList.contains('show')) {
            if (!event.composedPath().includes(this.dropdownMenuRef.nativeElement)) {
                this.toggleMenu();
            }
        } else {
            if (event.composedPath().includes(this.headerButtonRef?.nativeElement)) {
                this.toggleMenu();
            }
        }
    }
    // #endregion

    // #region [Type props]
    Enums = Enums;
    // #endregion

    // #region [signals]
    $isHintModeOn = signal(false);
    // #endregion

    // #region [Input/Output]
    @Input() _isHintModeOn = false;
    @Output() _hintModeChange = new EventEmitter<any>();
    // #endregion

    constructor(private router: Router) { }

    ngOnInit() {
        this.router.events.forEach(event => {
            if (event instanceof NavigationEnd) {
                this.$isHintModeOn.set(false);
                this._hintModeChange.emit(this.$isHintModeOn());
            }
        });
    }

    ngOnChanges() {
        this.$isHintModeOn.set(this._isHintModeOn);
    }

    toggleMenu() {
        this.dropdownMenuRef.nativeElement.classList.toggle('show');
    }

    onChange() {
        this.toggleMenu();
        setTimeout(() => this._hintModeChange.emit(this.$isHintModeOn()), 100);
    }

    // #region [===== private methods =====]
    // #endregion
}
